import { render, staticRenderFns } from "./ViewAllResearchGroups.html?vue&type=template&id=5e78e360&scoped=true&external"
import script from "./ViewAllResearchGroups.vue?vue&type=script&lang=js"
export * from "./ViewAllResearchGroups.vue?vue&type=script&lang=js"
import style0 from "./ViewAllResearchGroups.scss?vue&type=style&index=0&id=5e78e360&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78e360",
  null
  
)

export default component.exports